import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'Components/Button';


const EmptyState = props => {

  const { children, action, buttonText, className, icon } = props;

  let actionButton = null;
  const emptyStateClass = className ? `empty-state__${className}` : 'empty-state';
  const emptyTextStateClass = className ? `empty-state__text__${className}` : 'empty-state__text';
  const emptyButtonStateClass = className ? `empty-state__button__${className}` : 'empty-state__button';

  switch (typeof action) {
    case 'string':
      actionButton = (<Link title={ buttonText } to={ action }>{ buttonText }</Link>);
      break;

    case 'function':
      actionButton = (<Button className="btn btn--round" title={ buttonText }  onClick={ () => action() }>{ buttonText }</Button>);
      break;

    default:
      break;
  }

  const renderActionButton = () => {
    if (buttonText) {
      return (
        <div className={ emptyButtonStateClass }>
          { actionButton }
        </div>
      );
    }
  };

  return (
    <div className={ emptyStateClass }>
      { icon }
      <div className={ emptyTextStateClass }>
        { children }
      </div>
      { renderActionButton() }
    </div>
  );
};

EmptyState.propTypes = {
  children: PropTypes.node,
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  buttonText: PropTypes.string,
  icon: PropTypes.node,
  className: PropTypes.string
};

export default EmptyState;
